<template>
  <div class="min-height">
    <TableLoading v-if="tiers.page === 0"/>
    <div v-else>
      <form @submit.prevent="productAction">
        <div class="row">
          <div class="col-sm-4 mb-3">
            <label>Product Name</label>
            <input
                v-model="product.productName"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.productName.$error,
                      }"
            />
            <p
                v-for="error of v$.product.productName.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Official Product Name</label>
            <input
                v-model="product.officialProductName"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.officialProductName.$error,
                      }"
            />
            <p
                v-for="error of v$.product.officialProductName.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-3 mb-3">
            <label>Abbreviation</label>
            <input
                v-model="product.abbreviation"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.abbreviation.$error,
                      }"
            />
            <p
                v-for="error of v$.product.abbreviation.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <!--            -->
          <div class="col-sm-3 mb-3">
            <label>Product Code</label>
            <input
                v-model="product.code"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.code.$error,
                      }"
            />
            <p
                v-for="error of v$.product.code.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-3 mb-3">
            <label>JAN Code</label>
            <input
                v-model="product.jancode"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.jancode.$error,
                      }"
            />
            <p
                v-for="error of v$.product.jancode.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <!--            -->
          <div class="col-sm-3 mb-3">
            <label>ITF Code</label>
            <input
                v-model="product.itfcode"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.itfcode.$error,
                      }"
            />
            <p
                v-for="error of v$.product.itfcode.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-3 mb-3">
            <label>Quantity per(C/S)</label>
            <input
                v-model="product.quantityPerCase"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.quantityPerCase.$error,
                      }"
            />
            <p
                v-for="error of v$.product.quantityPerCase.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-3 mb-3">
            <label>Quantity per order unit</label>
            <input
                v-model="product.qpoUnit"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.qpoUnit.$error,
                      }"
            />
            <p
                v-for="error of v$.product.qpoUnit.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <!--            -->
          <div class="col-sm-3 mb-3">
            <label>Volume(ml)</label>
            <input
                v-model="product.volume"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.volume.$error,
                      }"
            />
            <p
                v-for="error of v$.product.volume.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-3 mb-3">
            <label>M3</label>
            <input
                v-model="product.m3"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.m3.$error,
                      }"
            />
            <p
                v-for="error of v$.product.m3.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-3 mb-3">
            <label>Minimum Order Unit</label>
            <multiselect v-model="product.minimumOrderUnit" :options="productOrderUnits" :class="{
                            'is-invalid': v$.product.minimumOrderUnit.$error,
                      }" class="multiselect-height-3" placeholder="Select one" label="name" track-by="name"></multiselect>
            <p
                v-for="error in v$.product.minimumOrderUnit.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>

          <!--            -->
          <div class="col-sm-4 mb-3">
            <label>Weight per(C/S)</label>
            <input
                v-model="product.caseWeight"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.caseWeight.$error,
                      }"
            />
            <p
                v-for="error of v$.product.caseWeight.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Weight per ball</label>
            <input
                v-model="product.bowlWeight"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.bowlWeight.$error,
                      }"
            />
            <p
                v-for="error of v$.product.bowlWeight.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Weight per unit</label>
            <input
                v-model="product.unitWeight"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.unitWeight.$error,
                      }"
            />
            <p
                v-for="error of v$.product.unitWeight.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <!--            -->
          <div class="col-sm-4 mb-3">
            <label>Expiry Period (in months)</label>
            <input
                v-model="product.expiryPeriod"
                name="name"
                type="number"
                step="any"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.product.expiryPeriod.$error,
                      }"
            />
            <p
                v-for="error of v$.product.expiryPeriod.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Launch Date</label>
            <date-picker v-model="product.launchDate" class="date-picker-height-3" format="YYYY-MM-DD" valueType="format"
                         :class="{'is-invalid': v$.product.launchDate.$error,}"></date-picker>
            <p
                v-for="error of v$.product.launchDate.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label> Available for Order Placement? </label>
            <select v-model="product.availableForOrder" class="form-control py-3">
              <option value=true> Yes </option>
              <option value=false> No </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 mb-3">
            <label>Select Product Unit</label>
            <multiselect v-model="selectedUnit" :options="productOrderUnits" class="multiselect-height-3" placeholder="Select Unit" label="name" track-by="name" @select="ChangePricing">
            </multiselect>
          </div>
          <div v-if="Object.keys(product.pricing).length > 0">
            <div class="row mt-5" v-for="tier in tiers.objects" :key="tier.publicId">
              <h4 class="card-title">{{ tier.name }}</h4>
              <div class="col-sm-4 mb-3" v-if="selectedUnit.name === 'Case'">
                <label>Basic C/S Price (Ksh)</label>
                <input
                    name="name"
                    type="number"
                    step="any"
                    class="form-control py-3"
                    :value="Object.values(product.pricing[tier.publicId])[0]"
                    @change="tierAddProductAmount($event, tier.publicId)"
                />
              </div>
              <div class="col-sm-4 mb-3" v-if="selectedUnit.name === 'Ball'">
                <label>Basic Ball Price (Ksh)</label>
                <input
                    @change="tierAddProductAmount($event, tier.publicId)"
                    :value="Object.values(product.pricing[tier.publicId])[0]"
                    name="name"
                    type="number"
                    step="any"
                    class="form-control py-3"
                />
              </div>
              <div class="col-sm-4 mb-3" v-if="selectedUnit.name === 'Piece'">
                <label>Basic P/C Price (Ksh)</label>
                <input
                    @change="tierAddProductAmount($event, tier.publicId)"
                    name="name"
                    type="number"
                    step="any"
                    :value="Object.values(product.pricing[tier.publicId])[0]"
                    class="form-control py-3"
                />
              </div>
            </div>
          </div>
          <!--            -->
          <div class="col-sm-6 mb-3">
            <label>Description</label>
            <ckeditor v-model="product.description" :editor="editor" :class="{
                        'is-invalid': v$.product.description.$error,
                      }"></ckeditor>
            <p
                v-for="error of v$.product.description.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
        </div>
        <div v-for="(error, index) in stockErrors" :key="index" style="color: #D13704;">
          {{error.message}}
        </div>
        <div class="mt-3 col-12">
          <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="stockLoading">
            <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Loading
          </b-button>
          <b-button variant="primary" size="lg" class="py-3 h3 w-100 text-white" type="submit" v-else>
            {{ button_text }}
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import CKEditor from "@ckeditor/ckeditor5-vue";
import useVuelidate from "@vuelidate/core";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {required} from "@vuelidate/validators";
import {ALL_CUSTOMER_TIERS} from "@/gql";
import {ALL_PRODUCTS_ORDER_UNITS} from "@/gql/stock";
import {mapGetters} from "vuex";
import TableLoading from "@/components/TableLoading";

export default {
name: "product-form-component",
  components: {TableLoading, Multiselect, ckeditor: CKEditor.component},
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      editor: ClassicEditor,
      selectedUnit: this.selected_unit,
      product: this.selected_product,
      tiers: {
        page: 0,
        objects: []
      },
      productOrderUnits: [],
    }
  },
  props: {
    selected_product: {
      type: Object,
      default(){
        return{
          thumbnail: "",
          productName: "",
          officialProductName: "",
          minimumOrderUnit: "",
          abbreviation: "",
          jancode: "",
          code: "",
          itfcode: "",
          quantityPerCase: "",
          volume: "",
          m3: "",
          qpoUnit: "",
          caseWeight: "",
          bowlWeight: "",
          unitWeight: "",
          expiryPeriod: "",
          launchDate: "",
          pricing: {},
          availableForOrder: true,
          description: "<h3>Description: </h3>",
        }
      }
    },
    selected_unit: {type: Object},
    button_text: {type: String}
  },
  apollo: {
    tiers: {
      query: ALL_CUSTOMER_TIERS,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    },
    productOrderUnits: {
      query: ALL_PRODUCTS_ORDER_UNITS
    }
  },
  validations () {
    return {
      product:{
        // thumbnail: {required},
        productName: {required},
        officialProductName: {required},
        minimumOrderUnit: {required},
        abbreviation: {required},
        jancode: {required},
        code: {required},
        itfcode: {required},
        quantityPerCase: {required},
        volume: {required},
        m3: {required},
        qpoUnit: {required},
        caseWeight: {required},
        bowlWeight: {required},
        unitWeight: {required},
        expiryPeriod: {required},
        launchDate: {required},
        description: {required},
      }
    }
  },
  computed: {
    ... mapGetters({
      stockLoading: 'stock/stockLoading',
      stockErrors: 'stock/stockErrors'
    }),
  },
  methods:{
    productAction() {
      const data = {
        ...this.product,
        availableForOrder: this.product.availableForOrder === 'true' ? true : false,
        quantityPerCase: parseInt(this.product.quantityPerCase),
        qpoUnit: parseInt(this.product.qpoUnit),
        expiryPeriod: parseInt(this.product.expiryPeriod),
        minimumOrderUnit: this.product.minimumOrderUnit.id,
        pricing: this.product.pricing,
      }
      // console.log(data)
      this.$emit('productAction', data)
      this.v$.$touch();
    },
    ChangePricing(){
      this.tiers.objects.forEach(tier => {
        this.product.pricing[tier.publicId] = {}
      });
    },
    tierAddProductAmount(event, tier_id){
      let pricing = this.product.pricing
      const inner = { [this.selectedUnit.id]: event.target.value}
      for (const key in pricing) {
        if(key === tier_id){
          pricing[key] = inner
        }
      }
      this.product.pricing = pricing
    },
  }
}
</script>

<style scoped>

</style>
